import { $host, $authHost, isDev } from './index'
import { httpPoint } from '../utils/const'

export const getList = async (type) => {
    const { data } = await $host.post(httpPoint.proxy + 'getList', { type })
    return data
}

export const getCalc = async ({
    type, country, period, count
}) => {
    const { data } = await $host.post(httpPoint.proxy + 'calculatePrice', { type, country, period, count })
    return data
}